
import { useCallback } from "react";
import { CellPosition } from "../types/workout-types";

export function useWorkoutNavigation(
  currentWeekIndex: number,
  setCurrentWeekIndex: (index: number) => void,
  activeCell: CellPosition | null,
  setActiveCell: (cell: CellPosition | null) => void,
  editMode: boolean,
  weekCount: number
) {
  // Navigation between weeks
  const goToPreviousWeek = useCallback(() => {
    if (currentWeekIndex > 0) {
      setActiveCell(null);
      return currentWeekIndex - 1;
    }
    return currentWeekIndex;
  }, [currentWeekIndex, setActiveCell]);

  const goToNextWeek = useCallback(() => {
    if (currentWeekIndex < weekCount - 1) {
      setActiveCell(null);
      return currentWeekIndex + 1;
    }
    return currentWeekIndex;
  }, [currentWeekIndex, weekCount, setActiveCell]);

  return {
    goToPreviousWeek,
    goToNextWeek
  };
}
